export default "__VITE_ASSET__9b68d2d5__"